import { useContext } from "react";
import VisiteServices from "../services/visiteServices";
import { AuthContext } from "../contexts/AuthContext";

export default function useVisite() {
  const { api } = useContext(AuthContext);
  const visiteService = new VisiteServices(api);

  const createVisite = async (data) => {
    const response = await visiteService.create(data);
    return response.data;
  };

  const getStatsVisites = async (filters = {}) => {
    const response = await visiteService.getStats(filters);
    return response.data;
  };

  const getAllVisites = async (filters = {}) => {
    const response = await visiteService.getAll(filters);
    return response.data;
  };

  return {
    createVisite,
    getStatsVisites,
    getAllVisites,
  };
}